import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/ui/design-system/components/ui/button';
import { buildUrl } from '../../tools/navigateTo';
import type { DashboardUrl } from '../types';

/**
 * The widgets' top-right dashboard link (the tables' "View all", the overview
 * card's "View page"). An empty pathname means no dashboard page exists for
 * this result (e.g. cat1 creators/posts, an unresolved entity route) — render
 * nothing rather than a dead link.
 */
const DashboardLink = ({
    link,
    label,
}: {
    link?: DashboardUrl;
    label: string;
}) =>
    link?.pathname ? (
        <Button
            variant="ghost"
            size="sm"
            asChild
            className="gap-1 text-primary shrink-0"
        >
            <Link to={buildUrl(link)}>
                {label}
                <ChevronRight />
            </Link>
        </Button>
    ) : null;

export default DashboardLink;
